export default "__VITE_ASSET__CXzRE0Ss__"